import { MarkupTooltipStyleClass } from '@tableau/data-catalog-client-components';
import { TextAreaProps, TextAreaWidget,TextFormatterProps, TextFormatterWidget } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

export type TextFormatterOrAreaWidgetProps = {
  id: string;
  useFormatter?: boolean;
  style?: React.HTMLAttributes<HTMLTextAreaElement>;
} & TextFormatterProps & TextAreaProps;

export function TextFormatterOrAreaWidget(props: TextFormatterOrAreaWidgetProps): React.ReactElement {
  const useFormatter = props.useFormatter === undefined ? FeatureFlags.markupEditingEnabled : props.useFormatter;
  const { markup, ...restProps } = props;

  return (
    useFormatter ?
      <TextFormatterWidget
        {...restProps}
        markup={markup}
        previewClassName={MarkupTooltipStyleClass}
      /> :
      <TextAreaWidget
        {...restProps}
        value={markup}
      />
  );
}
